export default {
  boothPrice: '展位价格',
  standard_booth: '标准展位',
  blank_booth: '光地展位',
  configuration: '配置',
  price: '价格',
  base: '基础',
  viewPrice: '查看价格',
  boothSampleGraph: '展位示意图',
  tip: '仅供参考，以实际展位配置为准',
  viewFloorPrice: '获取底价',
  configInfo1: {
    item1: '地毯',
    item2: '一桌',
    item3: '两（三）椅',
    item4: '一个废纸篓',
    item5: '公司楣板',
    item6: '两（三）个射灯',
    item7: '两（三）面墙板'
  },
  configInfo2: {
    item1: '不含任何设施',
    item2: '遵守展馆限制',
    item3: '需最小起订面积'
  }
}
